// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-48c0ae18] {\n  width: 70%;\n  height: 30px;\n}\n.item-category-row[data-v-48c0ae18] {\n  border-bottom: 1px solid var(--border-color);\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
